import { render, staticRenderFns } from "./DrivingSchoolsPage.vue?vue&type=template&id=6fa48cbe&lang=pug"
import script from "./DrivingSchoolsPage.vue?vue&type=script&lang=js"
export * from "./DrivingSchoolsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports